import type { ReferralAttempt } from '@/types/referrals';
import { CircleAlert, CircleCheck, CircleX, Loader2 } from 'lucide-react';
import { labels } from './ReferralDeliveryPanel.types';

interface Props {
  state?: ReferralAttempt['state'];
  pending: boolean;
  uncertain: boolean;
  failed: boolean;
}

export const ReferralSendFeedback = ({ state, pending, uncertain, failed }: Props) => {
  const feedback = pending
    ? { Icon: Loader2, text: labels.sending, tone: 'pending' }
    : uncertain || state === 'unknown' || state === 'needs_investigation' || state === 'sending'
      ? { Icon: CircleAlert, text: labels.unknown, tone: 'uncertain' }
      : state === 'confirmed'
        ? { Icon: CircleCheck, text: labels.confirmed, tone: 'success' }
        : state === 'rejected' || failed
          ? { Icon: CircleX, text: state === 'rejected' ? labels.rejected : 'Sending mistókst', tone: 'error' }
          : null;
  if (!feedback) return null;
  const { Icon, text, tone } = feedback;
  const color =
    tone === 'success'
      ? 'text-emerald-700 dark:text-emerald-400'
      : tone === 'error'
        ? 'text-red-700 dark:text-red-400'
        : tone === 'uncertain'
          ? 'text-amber-700 dark:text-amber-400'
          : 'text-muted-foreground';
  return (
    <span
      role={tone === 'error' ? 'alert' : 'status'}
      className={`inline-flex min-w-0 items-center gap-2 font-medium text-sm ${color}`}
    >
      <Icon aria-hidden="true" className={`h-5 w-5 shrink-0 ${pending ? 'animate-spin' : ''}`} />
      <span>{text}</span>
    </span>
  );
};
